/*
	CSS
*/
require('../bootstrap/css/bootstrap.css');
require('../css/font-awesome.min.css');
require('../css/animate.css');
require('../bootstrap/css/prettify.css');
require('../less/drunken-parrot.less');
require('../../shared/css/blocks.css');

/*
	scripts (as conventional globals)
*/
require("script!../js/vendor/jquery-1.11.0.min.js");
require("script!../bootstrap/js/bootstrap.min.js");
require("script!../bootstrap/js/prettify.js");
require('script!../../shared/js/maps.js');



//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/js/_headers.js
// module id = 0
// module chunks = 0 1 2 3 4 5 7 9